import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import style from './AboutChimp.module.css'
import AlternatingOne from './Alternating'
import AlternatingTwo from './Alternating2'

const features = [
  {
    number: '01',
    title: 'Your Briefing',
    text: 'A focused stream of opportunities matched to you jobs, courses, events, and connections. Powered by your CV, not your follows. No algorithm, no noise.',
  },
  {
    number: '02',
    title: 'Quick Chat',
    text: "Drop any job or opportunity into chat. Get a fit score, skill gaps, and the exact next step built on data from 45,000 companies in Sweden, not generic advice.",
  },
  {
    number: '03',
    title: 'Career Roadmaps',
    text: 'Step-by-step plans built for your goals switching industries, levelling up, or making a big move. Tailored to where you are, not where someone else started.',
  },
]

const cardVariants = {
  hidden: { opacity: 0, y: 32 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.12, ease: 'easeOut' },
  }),
}

const AboutChimp = () => {
  const navigate = useNavigate()

  return (
    <div className={style.mainContainer} id="about">
      <div className={style.container}>

        <motion.div
          className={style.headlineBlock}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className={style.rotateBlock}>
            <div className={style.rotateRow}>
              Are&nbsp;you&nbsp;<AlternatingOne />
            </div>
            <div className={style.rotateRow}>
              seeking&nbsp;<AlternatingTwo />
            </div>
          </div>
          <p className={style.tagline}>Your career, off the feed.</p>
          <p className={style.bodyText}>
            A platform built on factual data from 45,000 companies in Sweden not posts, not influencers, not the algorithm.
          </p>
        </motion.div>

        <motion.div
          className={style.divider}
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        />

        <div className={style.cardGrid}>
          {features.map(({ number, title, text }, i) => (
            <motion.div
              key={number}
              className={style.card}
              custom={i}
              variants={cardVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.15 }}
              whileHover={{ y: -6, transition: { duration: 0.2 } }}
            >
              <span className={style.cardNumber}>{number}</span>
              <h3 className={style.cardTitle}>{title}</h3>
              <p className={style.cardText}>{text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className={style.ctaRow}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          <motion.button
            className={style.button}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => {
              navigate('/?auth=login')
              window.scrollTo({ top: 0, behavior: 'smooth' })
            }}
          >
            Discover how →
          </motion.button>
        </motion.div>

      </div>
    </div>
  )
}

export default AboutChimp
